
export default {
  props: {
    value: {
      type: String,
      required: true,
      validator: (propValue) => {
        return ['link', 'password'].includes(propValue);
      },
    },
  },
  computed: {
    loginIsLink() {
      return this.value && this.value === 'link';
    },
  },
  methods: {
    loginMethodToggle() {
      this.$emit('input', this.value === 'link' ? 'password' : 'link');
    },
  },
};
